import Component from '@Component';
import trackEvent from '@Core/tracking';

const successClass = 'modal--success';

export default class XhrForm extends Component {
  static selector = '[data-comp-xhr-form]';
  static priority = 'in-view';

  constructor(element) {
    super(element);
    // TODO: break this out into an XHRForm component
    // I've marked form-specific methods with '_'
    this.$container = element;
    this.formContainer = this.$container;
    this.postPath = this.$container.getAttribute('action');

    if (this.formContainer) {
      this._initForm(this.formContainer);
      const button = this.formContainer.querySelector('button[type="submit"]');
      this.buttonText = button.querySelector('.btn__inner span');
      this.initialButtonText = this.buttonText.innerText;
    }
  }

  _resetButtonText() {
    this._changeButtonText(this.initialButtonText);
  }

  _changeButtonText(text) {
    this.buttonText.innerText = text;
  }

  _initForm(formEl) {
    this.formMessageContainer = this.$container.querySelector('[data-comp-xhr-form-message="success"]');
    this.allMessageContainers = formEl.querySelectorAll('[data-comp-form-message]');
    this.inputsContainer = this.$container.querySelector('[data-comp-xhr-form-inputs]');
    this._dynamicTextAreaHeight();
    this._eventsForm();
  }

  _dynamicTextAreaHeight() {
    const textAreaInputs = this.inputsContainer.querySelectorAll('textarea');
    textAreaInputs.forEach(el => {
      el.addEventListener('input', () => {
        const textarea = el;
        textarea.style.height = 'auto';
        if (textarea.value) {
          textarea.style.height = `${textarea.scrollHeight}px`;
        } else {
          textarea.style.height = '';
        }
      });
    });
  }

  _eventsForm() {
    this.formContainer.addEventListener('submit', e => this._submitForm(e));
  }

  _showServerSuccessMsg() {
    this._hideForm(() => {
      this.$container.classList.add(successClass);
    });
  }

  _hideForm(callback) {
    this.inputsContainer.addEventListener('transitionend', () => {
      this.inputsContainer.style.display = 'none';
      callback();
    });
    Object.assign(this.inputsContainer.style, {
      transition: 'all ease 100ms',
      opacity: 0,
    });
  }

  _showServerValidationMsg(resp) {
    renderMessage(this.formMessageContainer, resp.message, 'error');
  }

  _showServerErrorMsg() {
    renderMessage(
      this.formMessageContainer,
      '<strong>Error!</strong> Something went wrong. Please try again later while we check this out.',
      'error',
    );
  }

  _showServerPendingMsg() {
    this._changeButtonText('Sending...');
  }

  _resetForm() {
    this._clearFieldMessages();
    this._enableForm();
  }

  _appendSecureInput() {
    if (document.getElementById(`${this.$id}_secureInput`)) return;
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'secure';
    input.value = 'secure';
    input.id = `${this.$id}_secureInput`;
    this.inputsContainer.appendChild(input);
  }

  async _submitForm(e) {
    e.preventDefault();
    this._sendTrackingEvent();
    this._appendSecureInput();
    this._clearFieldMessages();
    this._disableForm();
    this._showServerPendingMsg();
    const resp = await fetch(this.postPath, {
      method: 'post',
      body: new FormData(e.target),
    });
    const data = await this._handleServerResponse(await resp);
    this._enableForm();
    this._handleValidationErrors(data);
  }

  async _handleServerResponse(resp) {
    const data = await resp.json();
    this._clearFieldMessages();
    if (resp.status === 200) {
      this._showServerSuccessMsg();
    } else if (resp.status === 422) {
      this._showServerValidationMsg(data);
    } else {
      this._showServerErrorMsg(data);
    }
    return data;
  }

  _handleValidationErrors(resp) {
    if (resp.errors) {
      this._handleFieldErrors(resp.errors);
    }
  }

  _handleFieldErrors(formErrors) {
    Object.keys(formErrors).forEach(fieldName => {
      formErrors[fieldName].forEach(err => {
        renderMessage(this.formContainer.querySelector(`[data-comp-form-message="${fieldName}"]`), err, 'error');
      });
    });
  }

  _clearFieldMessages() {
    this.allMessageContainers.forEach(el => {
      while (el.firstChild) el.removeChild(el.firstChild);
    });
  }

  _disableForm() {
    this.formContainer.querySelector('button[type="submit"]').disabled = true;
  }

  _enableForm() {
    this.formContainer.querySelector('button[type="submit"]').disabled = false;
  }

  _sendTrackingEvent() {
    const parentEl = this.$container.parentElement;
    if (parentEl.hasAttribute('data-xhr-track-event-data')) {
      const {
        eventCategory,
        eventAction,
        eventLabel,
      } = parentEl.dataset;
      trackEvent(eventCategory, eventAction, eventLabel);
    }
  }
}

function renderMessage(container, err, level) {
  container.insertAdjacentHTML('beforeend', getMessageHTML(err, level));
}

function getMessageHTML(message, level = 'notice') {
  return `<p class="sav-message sav-message--${level}">${message}</p>`;
}
